<template>
<div class="chapter">
<div class="inner_page">
<p class="ackhd">SPECIAL ACKNOWLEDGMENTS</p>
<p class="ack">I have been fortunate to have the most wonderful people helping me throughout the process of designing, writing, editing, and photographing this book. I would like to thank each and every person whose expertise has touched these pages. Special thanks go to Liz and Katie, my editors—you know how special you are, and I do appreciate you.</p>
<p class="ackt">Thank you also to those who bequeathed their precious bits of lace, fabric, trims, and buttons to me. I have enjoyed giving them a permanent home in my creations.</p>
<p class="fig"><img alt="image" src="images/pg2.jpg"/></p>
<blockquote class="Caption">Beaded Tandletons variation</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Fm_ack.vue?18008ec3